import Vue from 'vue'
import Router, { Route } from 'vue-router'
import Layout from '@/layout/index.vue'
import { campusMap } from './campuAffairs/index'
import { studentMap } from './students/index'
import { educationMap } from './education/index'
import { teachingProtectionMap } from './teachingProtection/index'
import { configureMap } from './configure/index'
import { institutionMap } from './institution/index'
import { institutionStudentMap } from './institutionStudent/index'
import { evaluationMap } from './evaluation/index'
import { setMap } from './set/index'
import { groupStatisticsMap } from './groupStatistics/index'
import { compareStatisticsMap } from './compareStatistics/index'
import { trendStatisticsMap } from './trendStatistics/index'
import { classCompareStatisticsMap } from './classCompareStatistics/index'
import { trendClassCompareStatisticsMap } from './trendClassCompareStatistics/index'
import { pdfPrevMap } from './pdfPrev/index'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export const constantRouterMap = [
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true, title: '登录' }
  },
  {
    path: '/show',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/show/index.vue'),
    meta: { hidden: true, title: '视频播放' }
  },
  {
    path: '/physicalAnalysis',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/physicalAnalysis/index.vue'),
    meta: { hidden: true, title: '体能分析报告' }
  },
  {
    path: '/settings',
    component: Layout,
    redirect: '/settings/account',
    meta: {
      title: '设置',
      hidden: true
    },
    children: [
      {
        path: 'account',
        component: () => import('@/views/settings/account/index.vue'),
        meta: {
          title: '个人信息'
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true, title: '404' }
  }
  // {
  //   path: '*',
  //   redirect: '/404',
  //   meta: { hidden: true }
  // }
]

export const asyncRouterMap = [
  {
    path: '/',
    meta: { hidden: true },
    component: Layout
  },
  campusMap, // 园务
  studentMap, // 学员
  evaluationMap, // 测评
  institutionStudentMap, // 学员
  institutionMap, // 机构
  educationMap, // 教务
  setMap, // 设置
  teachingProtectionMap, // 保教
  configureMap, // 配置
  groupStatisticsMap,
  compareStatisticsMap,
  classCompareStatisticsMap,
  trendStatisticsMap,
  trendClassCompareStatisticsMap,
  pdfPrevMap,
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]

export default new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,

  routes: constantRouterMap
})
